import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=c9b0a1ca&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9b0a1ca')) {
      api.createRecord('c9b0a1ca', component.options)
    } else {
      api.reload('c9b0a1ca', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=c9b0a1ca&", function () {
      api.rerender('c9b0a1ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2w9mqpECp4mbc/JS/pricehelp.vue"
export default component.exports